import { Box, Tab, Tabs, TabsProps, Typography, useTheme } from '@mui/material'
import dayjs from 'dayjs'
import { FC } from 'react'
import { themeMeta } from '../theme/meta'

const Weekdays: FC<WeekdaysProps> = ({ dates, value, onChange }) => {
  const theme = useTheme()

  const handleChange: TabsProps['onChange'] = (e, value) => {
    onChange(value)
  }

  return (
    <Box>
      <Tabs
        value={value}
        allowScrollButtonsMobile
        slotProps={{ indicator: { hidden: true } }}
        onChange={handleChange}
      >
        {dates.map((date) => (
          <Tab
            key={date.toString()}
            label={
              <>
                <Typography>{dayjs(date).format('ddd')}</Typography>
                <Typography variant="h3">{dayjs(date).format('D')}</Typography>
              </>
            }
            value={date}
            sx={{
              flexBasis: `${100 / 7}%`,
              minInlineSize: theme.spacing(13),
              py: 3 / 4,
              borderRadius: theme.spacing(1),

              '&.Mui-selected': {
                color: themeMeta.colors.monochrome.offWhite,
                backgroundColor: theme.palette.text.primary,
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
  )
}

type WeekdaysProps = {
  dates: string[]
  value: string
  onChange: (value: string) => void
}

export { Weekdays }
export type { WeekdaysProps }
